import theme, { responsiveFontSize } from "themes/Theme";

export const commonStyle = {
  cardStyle: {
    backgroundColor: theme.palette.background.default,
    borderRadius: "2.5em",
    boxShadow:
      "rgba(0, 0, 0, 0.1) 0px 0px 3px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px",
    padding: "1.5rem",
  },
  flexSpaceBetween: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
  },
  cardTitleText: {
    fontSize: responsiveFontSize(18),
    fontWeight: 400,
    color: theme.palette.text.primary,
  },
  inputLabelStyle: {
    fontSize: responsiveFontSize(14),
    fontWeight: 400,
    color: theme.palette.primary.main,
  },
  inputSlotTextStyle: {
    input: {
      sx: {
        fontSize: responsiveFontSize(14),
        color: theme.palette.text.primary,
        fontWeight: 400,
        lineHeight: 1.4,
      },
    },
  },
  fieldValueStyle: {
    fontSize: responsiveFontSize(16),
    fontWeight: 400,
    color: theme.palette.text.primary,
  },
};
